import appSettings from 'wanderu-config';
import { fetchCachedTripsAction as fetchCachedTripsPsearchAction } from 'wanderu-ducks-psearch';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';
import {
    actions as searchActions,
    selectors as searchSelectors,
} from '../../appstate/search';

const logger = Logger.getLogger('search-fetch-cached-trips');

function fetch(searchParams, serverBatchId) {
    return async (dispatch, getState) => {
        dispatch(actions.startWork(searchParams));

        if (serverBatchId) {
            dispatch(searchActions.setServerBatchId(serverBatchId));
        }

        let error;
        let meta = {};

        try {
            const psearchParams = {
                ...searchSelectors.selectPSearchParams(getState(), searchParams),
                batchId: searchParams.batchId || serverBatchId,
            };
            await dispatch(fetchCachedTripsPsearchAction.fetch(psearchParams));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(searchParams, meta, error));
        }
    };
}

function reset(searchParams) {
    return (dispatch, getState) => {
        const psearchParams = searchSelectors.selectPSearchParams(getState(), searchParams);
        dispatch(fetchCachedTripsPsearchAction.reset(psearchParams));
        dispatch(actions.reset(searchParams));
    };
}

function expire(opts) {
    return actions.expire(opts);
}

const fetchCachedTripsAction = {
    expire,
    fetch,
    reset,
    ...selectors,
};

export {
    fetchCachedTripsAction,
};

export default {
    [namespace]: reducer,
};
